import { IkpiModalTableStructure } from '@component/Modules/Kpi/Modal'

export const logisticKpiModalTableStructure: IkpiModalTableStructure[] = [
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Nome',
        id: 'categiria-compacta-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Sub Categoria',
    columns: [
      {
        name: 'Nome',
        id: 'subcategoria-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-codigo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'produto-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Lead Time',
    columns: [
      {
        name: 'Cadastrado (Dias)',
        id: 'lead-time-cadastrado-id',
        show: true
      },
      {
        name: 'Realizado (Dias)',
        id: 'lead-time-realizado-id',
        show: true
      }
    ]
  },
  {
    group: 'Recebimentos',
    columns: [
      {
        name: 'Pedidos',
        id: 'recebimentos-pedidos-id',
        show: true
      },
      {
        name: 'Quantidade',
        id: 'recebimentos-quantidade-id',
        show: true
      }
    ]
  }
]
